import cx from 'classnames';
import { jsx } from '@emotion/react';
const COLORS = {
    grey: 'uil-color-grey-700',
    'light-grey': 'uil-color-grey-300',
    white: 'uil-color-white',
};
const LINE_HEIGHTS = {
    big: 'uil-lh-big',
    bigger: 'uil-lh-bigger',
    small: 'uil-lh-small',
};
/** `Text` is the most used component of the UI-Library. It's a wrapper for simple texts. Every paragraph is using text.
 *
 * It can be used in parent components, like `TextBlock`.
 */
const Text = ({ children, color = 'grey', lineHeight = 'bigger', small = false, tag: CustomTag = 'p', ...other }) => {
    const { className: otherClassName, ...otherProps } = other;
    return (jsx(CustomTag, Object.assign({}, otherProps, { className: cx('uil-fw-normal uil-ff-poppins', small ? 'uil-fsz-14' : 'uil-fsz-16 lg:uil-fsz-18', LINE_HEIGHTS[lineHeight], COLORS[color], otherClassName) }), children));
};
Text.displayName = 'Text';
export default Text;
